<div class="w-[500pt]">
    <p-treetable [value]="stockData()" class="text-xs" styleClass="w-auto">
        <ng-template pTemplate="header">
            <tr class="!bg-transparent">
                <th class="!p-0 !pl-8 !text-left w-1/3 !bg-transparent">
                    <div class="w-full !text-left">
                        <i
                            class="fa-solid fa-warehouse clickable"
                            *ngIf="
                                dli()?.product?.productType === 'STORE' ||
                                dli()?.product?.productType === 'SIMPLEPRODUCTION'
                            "
                            pTooltip="{{ 'product.showWarehouseStockButton' | translate }}"
                            (click)="productStorageVisible.set(!productStorageVisible())"
                        ></i>
                    </div>
                </th>
                <th class="!p-0 !text-center !bg-transparent w-1/6">
                    {{ 'product.openSales' | translate }}
                </th>
                <th class="!p-0 !text-center !bg-transparent w-1/6">
                    {{ 'product.totalStock' | translate }}
                </th>
                <th class="!p-0 !text-center !bg-transparent w-1/6">
                    {{ 'product.ordered' | translate }}
                </th>
                <th class="!p-0 !text-center !bg-transparent w-1/6">
                    {{ 'product.reserved' | translate }}
                </th>
                <th class="!p-0 !text-center !bg-transparent w-1/6">
                    {{ 'product.quarantineStock' | translate }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entry>
            <tr class="!bg-transparent">
                <td class="!p-0 font-medium !text-left !pl-8">
                    {{ 'document-line-item.storage-place-short' | translate }}:
                    {{ entry.node?.name }}
                </td>
                @if (!this.liveChangesCurrentWarehouse()) {
                    <td class="!p-0 !text-center">
                        @if (entry.node?.loading) {
                            <p-skeleton width="3rem" height="1rem" />
                        } @else {
                            {{
                                entry.node?.openSales
                                    | decimalPlacesCustom
                                        : this.dli()?.unit?.decimalPlaces ||
                                              this.dli()?.decimalPlaces ||
                                              this.doc().decimalPlaces ||
                                              '1'
                            }}
                        }
                    </td>
                    <td class="!p-0 !text-center">
                        @if (entry.node?.loading) {
                            <p-skeleton width="3rem" height="1rem" />
                        } @else {
                            {{
                                entry.node?.totalStock
                                    | decimalPlacesCustom
                                        : this.dli()?.unit?.decimalPlaces ||
                                              this.dli()?.decimalPlaces ||
                                              this.doc().decimalPlaces ||
                                              '1'
                            }}
                        }
                    </td>
                    <td class="!p-0 !text-center">
                        @if (entry.node?.loading) {
                            <p-skeleton width="3rem" height="1rem" />
                        } @else {
                            {{
                                entry.node?.ordered
                                    | decimalPlacesCustom
                                        : this.dli()?.unit?.decimalPlaces ||
                                              this.dli()?.decimalPlaces ||
                                              this.doc().decimalPlaces ||
                                              '1'
                            }}
                        }
                    </td>
                    <td class="!p-0 !text-center">
                        @if (entry.node?.loading) {
                            <p-skeleton width="3rem" height="1rem" />
                        } @else {
                            {{
                                entry.node?.reserved
                                    | decimalPlacesCustom
                                        : this.dli()?.unit?.decimalPlaces ||
                                              this.dli()?.decimalPlaces ||
                                              this.doc().decimalPlaces ||
                                              '1'
                            }}
                        }
                    </td>
                    <td class="!p-0 !text-center">
                        @if (entry.node?.loading) {
                            <p-skeleton width="3rem" height="1rem" />
                        } @else {
                            {{
                                entry.node?.quarantineStock
                                    | decimalPlacesCustom
                                        : this.dli()?.unit?.decimalPlaces ||
                                              this.dli()?.decimalPlaces ||
                                              this.doc().decimalPlaces ||
                                              '1'
                            }}
                        }
                    </td>
                } @else {
                    <td class="!p-0 font-medium !text-center !pl-8" colspan="5">
                        {{ 'document-line-item.in-edit-save-for-changes' | translate }}
                    </td>
                }
            </tr>
        </ng-template>
    </p-treetable>
</div>

<p-drawer [(visible)]="productStorageVisible" position="right" styleClass="sidebar-style">
    <app-product-stock-chart-diagram
        [productId]="dli()?.product?.id"
        [stackLayout]="true"
        *ngIf="productStorageVisible() && dli()?.product?.id"
    ></app-product-stock-chart-diagram>
</p-drawer>
